<template>
  <a :href="url" :class="elementClass" :target="target ? target : undefined">
    <div class="dashboard-button-icon">
      <slot name="icon">
        <svg
          width="58"
          height="40"
          viewBox="0 0 58 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.8855 19.5938C37.8855 24.5125 33.898 28.5 28.9792 28.5C24.0605 28.5 20.073 24.5125 20.073 19.5938C20.073 14.675 24.0605 10.6875 28.9792 10.6875C33.898 10.6875 37.8855 14.675 37.8855 19.5938Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.479248 19.5938C0.479248 19.5938 11.1667 0 28.9792 0C46.7917 0 57.4792 19.5938 57.4792 19.5938C57.4792 19.5938 46.7917 39.1875 28.9792 39.1875C11.1667 39.1875 0.479248 19.5938 0.479248 19.5938ZM28.9792 32.0625C35.8655 32.0625 41.448 26.4801 41.448 19.5938C41.448 12.7074 35.8655 7.125 28.9792 7.125C22.0929 7.125 16.5105 12.7074 16.5105 19.5938C16.5105 26.4801 22.0929 32.0625 28.9792 32.0625Z"
            fill="black"
          />
        </svg>
        <p style="font-weight: 600; margin: 0.375rem 0 0.625rem 0">
          ObservNow™
        </p>
      </slot>
    </div>
    <div class="full-height-centered-flex-col">
      <p class="margin-auto">
        {{ label }}
        <i class="fas fa-chevron-right">
          <svg
            width="18px"
            height="18px"
            viewBox="0 0 512 512"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>chevron-right</title>
            <g
              id="Page-1"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="add"
                fill="#000000"
                transform="translate(149.333333, 80.853333)"
              >
                <polygon
                  id="Path"
                  points="-2.84217094e-14 320 30.1698893 350.169889 205.254834 175.084945 30.1698893 0 -2.84217094e-14 30.1698893 144.898278 175.084945"
                ></polygon>
              </g>
            </g>
          </svg>
        </i>
      </p>
    </div>
  </a>
</template>

<script>
export default {
  name: "DashboardButton",
  props: {
    url: {
      type: String,
      default: "/raft/incident-management/incident-report/create",
    },
    label: {
      type: String,
      default: "Safety Concern",
    },
    target: {
      type: String,
      default: "",
    },
    linkclass: {
      type: String,
      default: "homepage",
    },
  },
  computed: {
    elementClass() {
      return "el-cat-block-inner " + this.linkclass;
    },
  },
};
</script>

<style scoped>
.dashboard-button-icon {
  display: inline-block;
  height: 2rem;
}

div.full-height-centered-flex-col {
  font-size: 1rem;
  font-weight: 400;
  height: 4rem;
  color: var(--hx-text-primary, #141414);
  text-align: left;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}

div.full-height-centered-flex-col p {
  display: inline-block;
  line-height: 1rem;
  position: relative;
  margin: 0;
  text-wrap: auto;
  width: 80%;
}

div.full-height-centered-flex-col i {
  opacity: 0;
  line-height: 1.375rem;
  transition:
    250ms opacity,
    250ms transform;
  font-weight: 900;
  display: inline-block;
}

.el-cat-block-inner:hover div.full-height-centered-flex-col i {
  opacity: 1;
  transform: translate(0.25rem, 0);
}

a.protocols div.dashboard-button-icon,
a.knowledge-base div.dashboard-button-icon {
  padding: 0;
}
</style>
